<template>
  <div id="Register"><MainRegisterVendor /></div>
</template>

<script>
//import { MainRegisterVendor } from "../components/VendorProfile/MainRegisterVendor.vue";
export default {
  name: "Register",
  components: {
    MainRegisterVendor: () =>
      import("../components/VendorProfile/MainRegisterVendor.vue"),
  },
};
</script>

<style></style>
